import axios from './axiosInstance';

export const usersList = async (params = {}) => {
  const response = await axios.get("/club_api/users", { params });
  return response.data;
};

export const userDetails = async (id) => {
  const response = await axios.get("/club_api/users/" + id);
  return response.data;
};

export const updateUser = async (user) => {
  const response = await axios.put("/club_api/users/" + user?.id, { user });
  return response.data;
};

export const exportMembers = async (params = {}) => {
  const response = await axios.post("/club_api/users/export", { params })
  return response.data;
}

export const inviteUser = async (user) => {
  const response = await axios.post("/club_api/invites/", { user });
  return response.data;
};

export const removeFromClub = async (id) => {
  const response = await axios.delete("/club_api/users/" + id);
  return response.data;
};

export const removeFromTeam = async (teamId, userId) => {
  const response = await axios.delete(`/club_api/teams/${teamId}/users/${userId}` );
  return response.data;
};

export const removeInvite = async (id) => {
  const response = await axios.delete("/club_api/invites/" + id);
  return response.data;
};

export const clubUsersCount = async () => {
  const response = await axios.get("/club_api/users/users_count_by_role");
  return response.data;
}

export const invitesList = async (params = {}) => {
  const response = await axios.get("/club_api/invites", { params })
  return response.data;
}

export const clubsCount = async () => {
  const response = await axios.get("/club_api/clubs");
  return response.data;
}